// import React, { useState, useEffect } from "react";
// import toast from "react-hot-toast";
// import axios from "axios";

// const ShowAddIssue = () => {
//     const [issueList, setIssueList] = useState([]);
//     const [activeTypes, setActiveTypes] = useState(new Set());

//     useEffect(() => {
//         getIssueTypedata();
//     }, []);

//     const getIssueTypedata = async () => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/get-issue`,
//                 { withCredentials: true },
//             );
//             const data = res.data.data || [];
//             setIssueList(data);
//             const activeIds = data
//                 .filter((item) => item.isActive === true)
//                 .map((item) => item.id);
//             setActiveTypes(new Set(activeIds));
//         } catch (error) {
//             toast.error(
//                 error.response?.data?.message ||
//                     "Failed to fetch issue type data.",
//             );
//         }
//     };

//     const toggleType = async (id) => {
//         const currentlyActive = activeTypes.has(id);
//         const newActive = !currentlyActive;

//         // Optimistic update
//         setActiveTypes((prev) => {
//             const newSet = new Set(prev);
//             if (newActive) newSet.add(id);
//             else newSet.delete(id);
//             return newSet;
//         });

//         try {
//             // Adjust to your actual endpoint
//             await axios.patch(
//                 `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/toggle-issue?issueId=${id}`,
//                 null,
//                 { withCredentials: true },
//             );
//             toast.success(`Issue ${newActive ? "activated" : "deactivated"}`);
//         } catch (error) {
//             // Rollback
//             setActiveTypes((prev) => {
//                 const newSet = new Set(prev);
//                 if (newActive) newSet.delete(id);
//                 else newSet.add(id);
//                 return newSet;
//             });
//             toast.error("Failed to toggle issue status");
//         }
//     };

//     const isActive = (id) => activeTypes.has(id);

//     return (
//         <div className="p-6 bg-gray-50 min-h-screen font-sans">
//             <div className="max-w-3xl mx-auto">
//                 <h2 className="text-2xl font-bold text-gray-900 border-b-4 border-blue-500 pb-2 mb-6 inline-block">
//                     Issue Types
//                 </h2>

//                 {/* List of issue types from API */}
//                 <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//                     {issueList.map((type) => {
//                         const active = isActive(type.id);

//                         return (
//                             <div
//                                 key={type.id}
//                                 className={`
//                                     flex items-center justify-between px-4 py-3 border-b border-gray-100 last:border-0
//                                     transition-colors duration-150
//                                     ${active ? "bg-blue-50/60" : "hover:bg-gray-50"}
//                                 `}
//                             >
//                                 {/* Left: Label */}
//                                 <div className="flex items-center gap-3">
//                                     <span
//                                         className={`font-medium ${
//                                             active
//                                                 ? "text-blue-700"
//                                                 : "text-gray-700"
//                                         }`}
//                                     >
//                                         {/* Display name in a readable format */}
//                                         {type.name.charAt(0).toUpperCase() +
//                                             type.name.slice(1).toLowerCase()}
//                                     </span>
//                                     {active && (
//                                         <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                                             Active
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/* Right: Toggle button */}
//                                 <button
//                                     onClick={() => toggleType(type.id)}
//                                     className={`
//                                         relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
//                                         ${active ? "bg-blue-600" : "bg-gray-300"}
//                                     `}
//                                 >
//                                     <span
//                                         className={`
//                                             inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200
//                                             ${active ? "translate-x-6" : "translate-x-1"}
//                                         `}
//                                     />
//                                 </button>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ShowAddIssue;

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { ListChecks } from "lucide-react";

// Capitalizes the first letter, lowercases the rest (guards against missing name)
const formatTypeName = (name) => {
    if (!name) return "Untitled";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const ShowAddIssue = () => {
    const [issueList, setIssueList] = useState([]);
    const [activeTypes, setActiveTypes] = useState(new Set());
    const [loading, setLoading] = useState(true);
    const [togglingIds, setTogglingIds] = useState(new Set());

    useEffect(() => {
        getIssueTypedata();
    }, []);

    const getIssueTypedata = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/get-issue`,
                { withCredentials: true },
            );
            const data = res.data.data || [];
            setIssueList(data);
            const activeIds = data
                .filter((item) => item.isActive === true)
                .map((item) => item.id);
            setActiveTypes(new Set(activeIds));
        } catch (error) {
            toast.error(
                error.response?.data?.message ||
                    "Failed to fetch issue type data.",
            );
        } finally {
            setLoading(false);
        }
    };

    const toggleType = async (id) => {
        if (togglingIds.has(id)) return; // ignore double-click while a request is in flight

        const currentlyActive = activeTypes.has(id);
        const newActive = !currentlyActive;

        setTogglingIds((prev) => new Set(prev).add(id));

        // Optimistic update
        setActiveTypes((prev) => {
            const newSet = new Set(prev);
            if (newActive) newSet.add(id);
            else newSet.delete(id);
            return newSet;
        });

        try {
            // Adjust to your actual endpoint
            await axios.patch(
                `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/toggle-issue?issueId=${id}`,
                null,
                { withCredentials: true },
            );
            toast.success(`Issue ${newActive ? "activated" : "deactivated"}`);
        } catch (error) {
            // Rollback
            setActiveTypes((prev) => {
                const newSet = new Set(prev);
                if (newActive) newSet.delete(id);
                else newSet.add(id);
                return newSet;
            });
            toast.error("Failed to toggle issue status");
        } finally {
            setTogglingIds((prev) => {
                const newSet = new Set(prev);
                newSet.delete(id);
                return newSet;
            });
        }
    };

    const isActive = (id) => activeTypes.has(id);

    return (
        <div className="p-6 bg-gray-50 min-h-screen font-sans">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-2xl font-bold text-gray-900 border-b-4 border-blue-500 pb-2 mb-6 inline-block">
                    Issue Types
                </h2>

                {loading ? (
                    <div className="flex items-center justify-center rounded-xl border border-gray-200 bg-white py-16">
                        <div className="h-6 w-6 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
                    </div>
                ) : issueList.length === 0 ? (
                    <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-blue-300 bg-blue-50/30 py-16 text-center">
                        <ListChecks size={32} className="mb-2 text-blue-400" />
                        <p className="font-semibold text-gray-700">
                            No issue types yet
                        </p>
                        <p className="mt-1 text-sm text-gray-500">
                            Issue types you add will show up here.
                        </p>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        {issueList.map((type) => {
                            const active = isActive(type.id);
                            const isToggling = togglingIds.has(type.id);

                            return (
                                <div
                                    key={type.id}
                                    className={`
                                        flex items-center justify-between px-4 py-3 border-b border-gray-100 last:border-0
                                        transition-colors duration-150
                                        ${active ? "bg-blue-50/60" : "hover:bg-gray-50"}
                                    `}
                                >
                                    {/* Left: Label */}
                                    <div className="flex items-center gap-3">
                                        <span
                                            className={`font-medium ${
                                                active
                                                    ? "text-blue-700"
                                                    : "text-gray-700"
                                            }`}
                                        >
                                            {formatTypeName(type.name)}
                                        </span>
                                        {active && (
                                            <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                Active
                                            </span>
                                        )}
                                    </div>

                                    {/* Right: Toggle button */}
                                    <button
                                        onClick={() => toggleType(type.id)}
                                        disabled={isToggling}
                                        className={`
                                            relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
                                            ${active ? "bg-blue-600" : "bg-gray-300"}
                                            ${isToggling ? "opacity-60 cursor-not-allowed" : ""}
                                        `}
                                    >
                                        <span
                                            className={`
                                                inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200
                                                ${active ? "translate-x-6" : "translate-x-1"}
                                            `}
                                        />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShowAddIssue;
